import React from 'react';
import VendorRankings from '../components/VendorRankings';

const Home = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      {/* 頁面標題 */}
      <h1 className="text-3xl font-bold text-gray-800 mb-8">ESG 專案管理儀表板</h1>

      {/* 供應商填答排行榜 */}
      <VendorRankings />
    </div>
  );
};

export default Home;
